// import React from 'react';

import { useTranslation } from 'react-i18next';

import MyButton from '../button/Button';

interface DeleteWarningProperties {
  selectedRowId?: string | null;
  title: string;
  description: string;
  warningLabel?: string;
  cancelButtonLabel?: string;
  cancelButtonOnClick: () => void;
  submitButtonLabel?: string;
  submitSvgIcon?: JSX.Element;
  submitButtonOnClick: (rowId?: string | null) => void;
}

/**
 * Delete warning popup component
 * @param {any} properties properties
 * @returns {any} delete warning
 */
function DeleteWarning(properties: DeleteWarningProperties) {
  const { t } = useTranslation('sidePanel');
  const {
    selectedRowId,
    title,
    description,
    warningLabel,
    cancelButtonLabel,
    cancelButtonOnClick,
    submitButtonLabel,
    submitSvgIcon,
    submitButtonOnClick,
  } = properties;

  return (
    <div className="delete-warning-wrap">
      <div className="delete-waring-content">
        <h1>{title}</h1>
        <p>
          <span>{warningLabel || t('warning')}</span>
          <span>{description}</span>
        </p>
      </div>
      <div className="delete-button">
        <MyButton
          label={cancelButtonLabel || t('cancel', 'Cancel')}
          buttonType="back"
          onClickFunc={cancelButtonOnClick}
          disableHoverEffect
        />
        <MyButton
          label={submitButtonLabel || t('delete', 'Delete')}
          svgIcon={submitSvgIcon}
          buttonType="error"
          onClickFunc={() => submitButtonOnClick(selectedRowId)}
        />
      </div>
    </div>
  );
}

DeleteWarning.defaultProps = {
  selectedRowId: null,
  warningLabel: '',
  cancelButtonLabel: '',
  submitButtonLabel: '',
  submitSvgIcon: null,
};

export default DeleteWarning;
